/* eslint-disable @typescript-eslint/no-explicit-any */
import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import { filterRank, formatPhoneNumber } from '../../assets/ts/general/general'
import { MetadataContext } from '../../store/metadata-context-provider'
import { MAX_LENGTHS } from '../../utils/constants/global-constants'
import CustomSelect from '../../utils/controls/custom-select'
import InputText from '../../utils/controls/input-text'
import { CellPhoneProvider } from '../../utils/controls/select-options-data'

const DEFAULT_STYLES = {
  DetailsContainer: 'mb-1 col-12 col-sm-6 col-lg-4 col-xxl-20per mt-2',
  InfoClassName: 'tool-tip tooltip-top font-12 sourcesanspro',
  InputPropsClassName: 'font-12 poppins-medium title-color mb-1',
}

const selectValue = { label: 'Select', value: 'Select' }

const ProfileDetails = ({
  inputRefs,
  onChangeAssignedComponent,
  setUserInputs,
  userInputs,
}: {
  inputRefs: any
  onChangeAssignedComponent: any
  setUserInputs: any
  userInputs: any
}) => {
  const { components, ranks, tooltipObj } = useContext(MetadataContext)
  const [rankDDL, setRankDDL] = useState([selectValue])

  const [statusDDL, setStatusDDL] = useState([selectValue])
  const componentsOptions = components.map((component) => ({
    label: component.Component,
    value: component.ComponentCode,
  }))

  const handleChangeNumber = (e: any) => {
    const numbersOnly = (value: string, target: string) => {
      const numbersOnly = /^[0-9\b]+$/
      const numbersWithSymbolsAndSpace = /^[0-9()\b\s-]+$/
      if (value === '' || (numbersOnly.test(value) && value.length < 11)) {
        setUserInputs({ ...userInputs, [target]: value })
      }
      if (numbersWithSymbolsAndSpace.test(value) && value.length === 13) {
        const output = value.slice(0, -1).replace(/[^\d]/g, '')
        setUserInputs({ ...userInputs, [target]: output })
      }
    }
    numbersOnly(e.target.value, e.target.id)
  }
  const handleStatusChange = (e: any) => {
    const includeSelect = [selectValue]
    const { value } = e
    const filteredRank = filterRank(
      value,
      ranks,
      userInputs.AssignedComponentCode
    )
    const rankOption =
      filteredRank.length === 1
        ? filteredRank
        : [...includeSelect, ...filteredRank]
    setRankDDL(rankOption)
    setUserInputs({
      ...userInputs,
      ProfileStatus: value,
      Rank: filteredRank.length === 1 ? rankOption[0].value : 'Select',
    })
  }
  const handleRankChange = (e: any) => {
    const { value } = e
    setUserInputs({ ...userInputs, Rank: value })
  }
  const handlePhoneProviderChange = (e: any) => {
    const { value } = e
    setUserInputs({ ...userInputs, PersonalPhoneProvider: value })
  }

  const handletextChange = (e: any) => {
    const { value } = e.target
    checkForOnlySpaces(value)
      ? setUserInputs({ ...userInputs, PersonalEmail: '' })
      : setUserInputs({ ...userInputs, [e.target.id]: e.target.value })
  }

  const checkForOnlySpaces = (val) => /^\s*$/.test(val)

  useEffect(() => {
    const includeSelect = [selectValue]
    if (userInputs.ProfileStatus) {
      const filteredRank = filterRank(
        userInputs.ProfileStatus,
        ranks,
        userInputs.AssignedComponentCode
      )
      const rankOption =
        filteredRank.length === 1
          ? filteredRank
          : [...includeSelect, ...filteredRank]
      setRankDDL(rankOption)
    }
  }, [userInputs.ProfileStatus])

  useEffect(() => {
    const includeSelect = [selectValue]
    const profileStatusDDL = [
      ...new Set(
        ranks
          ?.filter(
            (assCom) =>
              assCom.AssignedComponentCode === userInputs.AssignedComponentCode
          )
          .map(({ Status }) => {
            return Status
          })
      ),
    ].map((rank) => {
      return { label: rank, value: rank }
    })
    const ddl = [...includeSelect, ...profileStatusDDL]
    setStatusDDL(ddl)
  }, [ranks, userInputs.AssignedComponentCode])
  return (
    <>
      <div className='p-2 bgcolor-21 w-100'>
        <h3
          aria-label='Personal Details '
          className='text-uppercase title-color51 poppins-semibold font-12 d-inline-block m-0 py-1 px-2'
          tabIndex={0}
        >
          Personal Details
        </h3>
      </div>
      <div className='px-3 py-2'>
        <div className='row forms-align-bottom'>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <InputText
              className='form-lg font-13 sourcesanspro'
              disabled
              formClassName=' form-vertical'
              info={tooltipObj.profileDodNumber?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
                id: 'DoDNumber',
                maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                name: 'DoD ID Number',
                value: userInputs.DoDNumber,
              }}
              isInfo
              isMandatory
              label='DoD ID Number'
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical'
              id='AssignedComponent'
              info={tooltipObj.profileAssignedComp?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
              }}
              isInfo
              isMandatory
              label='Assigned Component'
              name='Assigned Component'
              onChange={(e: string) => onChangeAssignedComponent(e)}
              options={componentsOptions}
              value={userInputs.AssignedComponentCode}
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap'
              id='ProfileStatus'
              info={tooltipObj.profileStatus?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
              }}
              isInfo
              isMandatory
              label='Status'
              name='Status'
              onChange={(e: string) => handleStatusChange(e)}
              options={statusDDL}
              ref={inputRefs.ProfileStatus}
              value={userInputs.ProfileStatus}
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap'
              id='ProfileRank'
              info={tooltipObj.profileRank?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
              }}
              isInfo
              isMandatory
              label='Rank'
              name='Rank'
              onChange={(e: string) => handleRankChange(e)}
              options={rankDDL}
              ref={inputRefs.Rank}
              value={userInputs.Rank}
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <InputText
              className='form-lg font-13 sourcesanspro'
              disabled
              formClassName=' form-vertical'
              info={tooltipObj.profileDutyEmail?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
                id: 'DutyEmail',
                maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                name: 'Duty Email',
                value: userInputs.DutyEmail,
              }}
              isInfo
              isMandatory
              label='Duty Email'
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <InputText
              changeHandler={(e: any) => handleChangeNumber(e)}
              className='form-lg font-13 sourcesanspro'
              formClassName=' form-vertical'
              info={tooltipObj.profileDutyPhone?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
                id: 'DutyPhone',
                maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                name: 'Duty Phone',
                placeholder: ' (123) 213-1231',
                value: formatPhoneNumber(userInputs.DutyPhone as string),
              }}
              isInfo
              isMandatory
              label='Duty Phone'
              ref={inputRefs.DutyPhone}
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <InputText
              changeHandler={(e: any) => handleChangeNumber(e)}
              className='form-lg font-13 sourcesanspro'
              formClassName=' form-vertical'
              info={tooltipObj.profileCellPhone?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
                id: 'PersonalPhone',
                maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                name: 'Personal Phone Number',
                placeholder: ' (123) 213-1231',
                value: formatPhoneNumber(userInputs.PersonalPhone as string),
              }}
              isInfo
              label='Personal Phone Number'
              ref={inputRefs.PersonalPhone}
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap'
              id='PersonalPhoneProvider'
              info={tooltipObj.profileCellProvider?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
              }}
              isInfo
              label='Personal Phone Provider'
              name='Personal Phone Provider'
              onChange={(e: string) => handlePhoneProviderChange(e)}
              options={CellPhoneProvider}
              value={userInputs.PersonalPhoneProvider}
            />
          </div>
          <div className={DEFAULT_STYLES.DetailsContainer}>
            <InputText
              changeHandler={(e: any) => handletextChange(e)}
              className='form-lg font-13 sourcesanspro'
              formClassName=' form-vertical'
              info={tooltipObj.profilePersonalEmail?.TooltipDescription}
              infoClassName={DEFAULT_STYLES.InfoClassName}
              infoIcon='icon-info color-primary'
              inputProps={{
                className: DEFAULT_STYLES.InputPropsClassName,
                id: 'PersonalEmail',
                maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                name: 'Personal Email',
                placeholder: 'Enter Personal Email',
                value: userInputs.PersonalEmail,
              }}
              isInfo
              label='Personal Email'
              ref={inputRefs.PersonalEmail}
            />
          </div>
        </div>
      </div>
    </>
  )
}

ProfileDetails.propTypes = {
  onChangeInputSelect: PropTypes.func,
}

export { DEFAULT_STYLES }
export default ProfileDetails
